import { render, staticRenderFns } from "./passbookfees.vue?vue&type=template&id=6def5a0f"
import script from "./passbookfees.vue?vue&type=script&lang=js"
export * from "./passbookfees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports